import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import Devices from './Devices.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * ModelViewer component
 */
export default class ScrollingEventail extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */

  breakpoints = ['xxs', 'xs', 's'];

  static config = {
    name: 'ScrollingEventail',
    refs: [
      'items[]',
      'intro',
      'content[]',
      'eventail',
      'devices[]',
      'devicesWrapper',
      'devicesContainer',
    ],
    components: {
      Devices,
    },
    options: {
      end: {
        type: Number,
        default: 200,
      },
    },
  };

  /**
   *
   */
  mounted() {
    this.currentDevice = this.$children.Devices[0];
    this.index = 0;

    gsap.to(this.$refs.items, {
      y: 0,
      x: 0,
      rotate: 0,
      scale: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: this.$refs.intro,
        start: 'top top',
        end: '70%',
        ease: 'none',
        scrub: true,
        inertia: false,
        onEnterBack: () => {
          this.$refs.eventail.classList.remove('!opacity-0');
        },
      },
      onComplete: () => {
        this.$refs.eventail.classList.add('!opacity-0');
      },
    });

    this.currentActiveIndex = -1;
    this.isTransitioning = false;

    const observer = new IntersectionObserver(this.checkIntersection.bind(this), {
      threshold: 0.8,
    });

    this.$refs.content.forEach((target) => {
      observer.observe(target);
    });
  }

  /**
   * Check message intersection with mobile
   * @param  {object} entries
   * @returns {void}
   */
  checkIntersection(entries) {
    if (entries[0].isIntersecting) {
      const index = this.$refs.content.indexOf(entries[0].target);

      if (this.isMobile) {
        if (index === 0) {
          this.$refs.eventail.classList.remove('opacity-0');
        }

        if (index === 1) {
          this.$refs.eventail.classList.add('opacity-0');
        }
      }

      if (this.index === index) {
        return;
      }

      this.index = index;

      const tl = gsap.timeline({
        onStart: () => {
          this.oldDevice = this.currentDevice;
          this.currentDevice = this.$children.Devices[this.index];
        },
        onComplete: () => {
          this.oldDevice.hideHotspot();
          this.currentDevice.showHotspot();
        },
      });

      tl.to(this.$refs.devicesWrapper, {
        yPercent: -100 * this.index,
        duration: 0.5,
        ease: 'back.inOut',
      });
    }
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }
}
